import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const services = [
  "Payment Processing & Orchestration",
  "High-Risk Merchant Operations",
  "Subscription / Rebill Flows",
  "API & Webhook Integrations",
  "QA / UAT / Incident Investigation",
  "E-commerce (Shopify / WooCommerce)",
  "Other",
];

export default function ContactPage() {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    business_name: "",
    business_type: services[0],
    message: "",
  });
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const onChange = (e) =>
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      await axios.post(`${API}/contact`, form);
      setStatus({
        state: "ok",
        msg: "Thanks — message received. I'll reply from rryzhov@gmail.com within 24h.",
      });
      setForm({
        first_name: "",
        last_name: "",
        email: "",
        business_name: "",
        business_type: services[0],
        message: "",
      });
    } catch (err) {
      setStatus({
        state: "error",
        msg:
          err?.response?.data?.detail?.[0]?.msg ||
          "Could not send the message. Please email rryzhov@gmail.com directly.",
      });
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="border-b border-ink-900/10">
        <div className="wrap grid gap-14 py-20 md:grid-cols-12 md:py-28">
          {/* Left — addressed by Roman */}
          <div className="md:col-span-5">
            <p className="eyebrow">§ Contact</p>
            <h1 className="display mt-4 text-5xl font-medium leading-[1.02] sm:text-6xl">
              Tell me what's
              <br />
              <em className="font-normal italic text-clay-600">
                breaking
              </em>{" "}
              in your
              <br />
              payment stack.
            </h1>

            <div className="mt-10 space-y-6 text-[15.5px] text-ink-800">
              <div>
                <p className="label">Direct email</p>
                <a
                  href="mailto:rryzhov@gmail.com"
                  className="display link-underline text-2xl font-medium"
                  data-testid="contact-email-link"
                >
                  rryzhov@gmail.com
                </a>
              </div>

              <div className="rule" />

              <div>
                <p className="label">Operator</p>
                <p className="text-ink-900">Roman Ryzhov</p>
              </div>
              <div>
                <p className="label">Studio</p>
                <p className="text-ink-900">VRH Digital</p>
              </div>
              <div>
                <p className="label">Based in</p>
                <p className="text-ink-900">Kharkiv, Ukraine</p>
              </div>
              <div>
                <p className="label">Response time</p>
                <p className="text-ink-900">
                  Usually within 24h, Mon–Fri (Kyiv time)
                </p>
              </div>
            </div>
          </div>

          {/* Right — form */}
          <div className="md:col-span-7">
            <form
              onSubmit={onSubmit}
              className="border border-ink-900/10 bg-paper p-7 sm:p-10"
              data-testid="contact-form"
            >
              <p className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-ink-500">
                Project brief — vrhdigital.com / 01
              </p>
              <h2 className="display mt-2 text-3xl font-medium">
                A few quick lines.
              </h2>

              <div className="mt-10 grid gap-7 sm:grid-cols-2">
                <div>
                  <label className="label" htmlFor="first_name">
                    First name
                  </label>
                  <input
                    id="first_name"
                    name="first_name"
                    required
                    value={form.first_name}
                    onChange={onChange}
                    className="input"
                    placeholder="Jane"
                    data-testid="input-first-name"
                  />
                </div>
                <div>
                  <label className="label" htmlFor="last_name">
                    Last name
                  </label>
                  <input
                    id="last_name"
                    name="last_name"
                    required
                    value={form.last_name}
                    onChange={onChange}
                    className="input"
                    placeholder="Doe"
                    data-testid="input-last-name"
                  />
                </div>

                <div className="sm:col-span-2">
                  <label className="label" htmlFor="email">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={onChange}
                    className="input"
                    placeholder="you@company.com"
                    data-testid="input-email"
                  />
                </div>

                <div>
                  <label className="label" htmlFor="business_name">
                    Company / project
                  </label>
                  <input
                    id="business_name"
                    name="business_name"
                    value={form.business_name}
                    onChange={onChange}
                    className="input"
                    placeholder="Acme Pay"
                    data-testid="input-business"
                  />
                </div>

                <div>
                  <label className="label" htmlFor="business_type">
                    Need
                  </label>
                  <select
                    id="business_type"
                    name="business_type"
                    value={form.business_type}
                    onChange={onChange}
                    className="input"
                    data-testid="input-need"
                  >
                    {services.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="sm:col-span-2">
                  <label className="label" htmlFor="message">
                    What's going on?
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    value={form.message}
                    onChange={onChange}
                    className="input resize-none"
                    placeholder="A short brief: verticals, current gateways/PSPs, the symptom you're seeing."
                    data-testid="input-message"
                  />
                </div>
              </div>

              <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-500">
                  No spam · no list · just a reply
                </p>
                <button
                  type="submit"
                  disabled={status.state === "loading"}
                  className="btn-primary"
                  data-testid="contact-submit"
                >
                  {status.state === "loading"
                    ? "Sending…"
                    : "Send brief →"}
                </button>
              </div>

              {status.state === "ok" && (
                <p
                  className="mt-6 border-t border-ink-900/10 pt-5 text-[14.5px] text-moss-500"
                  data-testid="contact-success"
                >
                  ✓ {status.msg}
                </p>
              )}
              {status.state === "error" && (
                <p
                  className="mt-6 border-t border-ink-900/10 pt-5 text-[14.5px] text-clay-600"
                  data-testid="contact-error"
                >
                  ✗ {status.msg}
                </p>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
